<i18n src="@/locales/components/views/packing_house/production/uniq_final_packing_list/package_from_stock.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/package.yml" lang="yaml"></i18n>
<template>
  <div class="sm:col-span-8 md:flex">
    <div class="flex-none pr-1">
      <label class="label-form">{{ $t("model.package.week") }}</label>
      <div class="mt-1">
        <select-form class="flex-auto" :options="week_options" :disabled="!filter_applied" :clearable="false" v-model="week" ></select-form>
      </div>
    </div>
    <div class="flex-auto text-left">
      <label class="label-form">{{ $t("model.package._self") }}</label>
      <div class="mt-1 text-left">
        <div class="text-[#5c7a2e] pt-1" v-if="render_filter && !filter_applied">
          <i class="fa-solid fa-circle fa-beat-fade" style="--fa-animation-duration: 2s; --fa-animation-delay: 0s">
          </i>
          <span class="space-icon"></span>
          <i class="fa-solid fa-circle fa-beat-fade" style="--fa-animation-duration: 2s; --fa-animation-delay: 0.5s">
          </i>
          <span class="space-icon"></span>
          <i class="fa-solid fa-circle fa-beat-fade" style="--fa-animation-duration: 2s; --fa-animation-delay: 1s">
          </i>
          <span class="space-icon"></span>
          <i class="fa-solid fa-circle fa-beat-fade" style="--fa-animation-duration: 2s; --fa-animation-delay: 1.5s">
          </i>
        </div>
        <select-form
          v-else
          class="flex-auto"
          :options="to_assign_packages"
          :clearable="from_form"
          :disabled="disable_package_selector"
          v-model="id"
          label="full_label"
        />
      </div>
    </div>
    <div class="flex-none pl-1" v-if="render_quantity && filter_applied">
      <label class="label-form">{{ $t("model.package.quantity") }}</label>
      <div class="mt-1">
        <input
          type="number"
          min="1"
          :max="this.max_quantity"
          v-model.number.lazy="quantity"
          @change="quantity = parsedQuantity(quantity)"
          :class="['input-text']"
          :disabled="disable_package_selector"
          autofocus
        />
      </div>
    </div>
    <div class="flex-none pl-1 pt-6 text-right" v-if="allow_create_package && from_form">
      <button
        class="mt-1"
        @click.prevent="$emit('changeToNewPackage')"
        :title="$t('labels.add_package_link')"
      >
        <i class="fa-solid fa-plus fa-lg px-1"></i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "PackageFromStock",
  props: {
    default: {
      type: Object,
      default: null,
    },
    modelValue: {},
    allow_create_package: { default: false },
    packing_house_process_id: {  },
    container_id: {  },
    total: { type: Number, required: true },
    weeks: { type: Array, default: () => { return [] } },
    default_week: { type: Number },
    unassigned_packages: { type: Array, required: true },
    unassigned_packages_by_weeks: { type: Object, required: true },
    new_assigned_package_ids: { type: Array, default: () => { return [] } },
    fetchPackages: { type: Function }
  },
  data() {
    return {
      id: this.modelValue,
      quantity: null,
      week: null,
      render_quantity: false,
      packages: this.unassigned_packages,
      filter_applied: true,
    };
  },
  computed: {
    any_filter: function () {
      return this.week != null;
    },
    current_option: function () {
      if (this.id) return this.packages.find((option) => option.id == this.id);
      return null;
    },
    default_data_is_selected: function () {
      if (this.current_option && this.default) {
        let same_id = this.current_option.id == this.default.id;
        let same_week = true;
        if (this.render_filter) {
          same_week = this.current_option.week == this.default.week;
        }
        return same_id && same_week;
      }
      return false;
    },
    filters: function () {
      return { 'week': this.week };
    },
    from_form: function () {
      // que solo ha sido creado en el formulario pero todavia no en rails.
      if (this.default) return this.default.from_form || false;
      return true;
    },
    max_quantity: function () {
      if (this.current_option) return Math.floor(this.current_option.quantity);
      return 1;
    },
    render_filter: function () {
      return this.total > 100;
    },
    disable_package_selector: function () {
      return this.render_filter && (!this.filter_applied || !this.any_filter);
    },
    option_is_stil_assignable: function () {
      if (this.current_option) return this.to_assign_package_ids.includes(this.current_option.id);
      return false;
    },
    // totdos los paquetes disponibles para asignar asignar.
    to_assign_packages: function () {
      return this.packages.filter(
        (package_item) =>
          !this.new_assigned_package_ids.includes(package_item.id) || this.isActualPackage(package_item)
      );
    },
    to_assign_package_ids: function () {
      return this.to_assign_packages.map(pkg => pkg.id);
    },
    week_options: function () {
      return this.weeks.map(week => { return { id: week, name: week } })
    },
  },
  watch: {
    id: function (id) {
      this.$emit("update:modelValue", id);
    },
    current_option: function (option) {
      if (option) {
        let quantity = option.id == this.default?.id ? this.default.quantity : option.quantity;
        quantity = this.parsedQuantity(quantity);
        this.quantity = quantity;
        return (this.render_quantity = true);
      }

      this.render_quantity = false;
    },
    quantity: function (quantity) {
      this.$emit("update:quantity", quantity);
    },
    filters: async function () {
      if (!this.filter_applied) return;

      this.filter_applied = false;
      await this.fetchUnassignedPackages(this.filters);
      if (!this.option_is_stil_assignable) this.id = null;
      this.filter_applied = true;
    },
    week: function(week) {
      this.$emit("update:week", week)
    }
  },
  methods: {
    isActualPackage: function (pkg) {
      if (this.current_option) {
        if (pkg.id == this.current_option.id) return true;
      }
      return false;
    },
    isAlreadyAssigned: function(pkg) {
      this.new_assigned_package_ids.includes(pkg.id)
    },
    fetchUnassignedPackages: async function () {
      if (this.unassigned_packages_by_weeks[this.week]) {
        this.packages = this.unassigned_packages_by_weeks[this.week];
      } else {
        let data = await this.fetchPackages(this.filters);
        this.packages = data.packages;
        this.$emit('udpateUnassignedPackagesByWeek', this.week, this.packages);
      }
    },
    setDefaultOption: function () {
      // if (this.render_filter) {
        this.week = this.default.week;
      // }
      this.id = this.default.id;
      this.quantity = this.default.quantity;
      this.render_quantity = true;
    },
    parsedQuantity: function (value) {
      let parsed_value = Math.floor(value);
      const max = this.max_quantity;

      if (parsed_value > max) return max;
      else if (parsed_value < 1) return 1;
      else return parsed_value;
    },
  },
  mounted: function () {
    if (this.default && this.default.id) this.setDefaultOption();
    else if (this.default_week) this.week = this.default_week;
  },
};
</script>

<style></style>
